import lazyload from 'app/libs/lazyload';

export const DiagnosisIntroPage = lazyload(() => import('./DiagnosisIntroPage'));
export const DiagnosisSheetPrintPage = lazyload(() => import('./DiagnosisSheetPrintPage'));

// common
export const RedirectPage = lazyload(() => import('../common/RedirectPage'));
